import { render, staticRenderFns } from "./TextileEditor.vue?vue&type=template&id=61ac7d5f&"
import script from "./TextileEditor.vue?vue&type=script&lang=js&"
export * from "./TextileEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports